module.exports = __webpack_public_path__ + "img/gundula.203ab50a.gif";